module.exports = __webpack_public_path__ + "img/2.8734895d.png";